import React from "react";
import { Box, Typography, Grid, IconButton, Paper } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import { Irai } from "../types/GxpTypes";
import { useData } from "../utils/DataContext";
import { RenderColumn } from "../utils/IraiDisplayUtils";
import { getDisplayEntriesForDetail, splitEntriesForColumns } from "../utils/DisplayUtils";

type IraiDetailModalProps = {
  irai: Irai | null;
  open: boolean;
  onClose: () => void;
};

const IraiDetailModal: React.FC<IraiDetailModalProps> = ({ irai, open, onClose }) => {
  const { getMaster } = useData();

  if (!open || !irai) return null;

  const displayEntries = getDisplayEntriesForDetail(irai);
  const [leftColumnEntries, rightColumnEntries] = splitEntriesForColumns(displayEntries);

  return (
    <Box
      sx={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100vw',
        height: '100vh',
        backgroundColor: 'rgba(0, 0, 0, 0.5)',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        zIndex: 1300,
      }}
      onClick={onClose}
    >
      <Paper
        sx={{
          width: '90%',
          maxWidth: '800px',
          maxHeight: '80vh',
          overflow: 'auto',
          p: 3,
          position: 'relative',
        }}
        onClick={(e) => e.stopPropagation()}
      >
        <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', mb: 2 }}>
          <Typography variant="h6">
            依頼詳細 - ID: {irai.id}
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>

        <Grid container spacing={2}>
          <Grid item xs={6}>
            <RenderColumn entries={leftColumnEntries} getMaster={getMaster} />
          </Grid>
          <Grid item xs={6}>
            <RenderColumn entries={rightColumnEntries} getMaster={getMaster} />
          </Grid>
        </Grid>
      </Paper>
    </Box>
  );
};

export default IraiDetailModal;
